import { CircularProgress } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import iconRevenue from "src/assets/images/admin-dashboard/revenue-icon.png";
import httpRequest from 'src/helpers/httpRequest';
import { CURRENCY } from 'src/lib/constans';

type stateKeys = "totalRevenue" | "monthlyRevenue" | "testRevenue" | "consultationRevenue" | "pharmaRevenue" | "homecareServiceRevenue";
interface IItems {
    key: stateKeys;
    icon: string;
    title: string;
    value: number | null;
};

interface IResponseCount {
    totalRevenue: number;
    monthlyRevenue: number;
    testRevenue: number;
    consultationRevenue: number;
    pharmaRevenue: number;
    homecareServiceRevenue: number;
};

const RevenueStatistics: React.FC = () => {
    const [data, setData] = useState<IItems[]>([
        {
            key: "totalRevenue",
            icon: iconRevenue,
            title: "Total Revenue",
            value: null,
        },
        {
            key: "monthlyRevenue",
            icon: iconRevenue,
            title: "This Months Revenue",
            value: null,
        },
        {
            key: "testRevenue",
            icon: iconRevenue,
            title: "Diagnostics Revenue",
            value: null,
        },
        {
            key: "consultationRevenue",
            icon: iconRevenue,
            title: "Consultation Revenue",
            value: null,
        },
        {
            key: "pharmaRevenue",
            icon: iconRevenue,
            title: "Pharmacy Revenue",
            value: null,
        },
        {
            key: "homecareServiceRevenue",
            icon: iconRevenue,
            title: "At Home Revenue",
            value: null,
        }
    ]);

    const [isLoader, setIsLoader] = useState<boolean>(false);

    const fetchRevenuedStats = async () => {
        setIsLoader(true);
        const { res, err } = await httpRequest<{ data: IResponseCount; message: string; }>({ path: "/pharma-order/admin/statistics/revenue-monthly" });
        if (res) {
            Object.entries(res?.data).map(([key, value]) => {
                setData(prev => prev.map(v => v.key === key ? { ...v, value } : v));
            });
        } else {
            toast(err, { type: 'error' });
        }
        setIsLoader(false);
    };

    useEffect(() => {
        fetchRevenuedStats();
    }, []);
    return (
        <div className="parent-box parent-box-dashboard">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-3">
                {
                    data.map((item, index) => (
                        <div key={index} className="dashboard-sm-box h-auto">
                            <div className="dashboard-inner-box w-[80%] text-center">
                                <img className='admin-dashboard-img' src={item.icon} alt="biomarker-icon" />
                                <p className="font-Poppins-Medium font-size-18px">
                                    {item.title}
                                </p>
                                {
                                    isLoader
                                        ?
                                        <CircularProgress size={20} className="theme-color-green" />
                                        :
                                        <p className="font-Poppins-SemiBold font-size-23px theme-color-green">
                                            {`${CURRENCY} ${item.value?.toFixed(2) || "-"}`}
                                        </p>
                                }
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
    );
};

export default RevenueStatistics;